const AUTH_PROVIDERS_QUERY = `
  query AuthProvidersQuery($email: String!) {
    public {
      authProviders(email: $email)
    }
  }
`;

export default AUTH_PROVIDERS_QUERY;
